export const APPLICATIONS = [
  {
    key: 1,
    id:'4f700ae1-f6f8-4242-9f6c-bc9fc6657bc3',
    aa: '102581',
    afm: '511213247',
    name: 'Ι.Λαντζανάτου ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ ΕΜΠΟΡΙΑ ΗΛΕΚΤΡΟΛΟΓΙΚΩΝ',
    investmentPlace: 'Θεσσαλονίκη',
    activeTaskId: 'submit_application',
    programs: [
      'ΕΣΠΑ - Πράσινος Μετασχηματισμός ΜμΕ',
      'Βελτίωση της ενεργειακής απόδοσης επιχειρήσεων',
    ],
    programsCount: 2,
    fundingScheme: {
      totalBudget: '330.000.000,00€',
      grant: '165.000.000,00€',
      ownParticipation: '66.000.000,00€',
      bankLoan: '99.000,00€',
    },
    applicationDate: '25/05/2024',
    submissionDate: '-',
  },
  {
    key: 2,
    id:'4f700ae1-f6f8-4242-9f6c-bc9fc6657bc3',
    aa: '102582',
    afm: '622213247',
    name: 'Ι.Λαντζανάτου ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ ΕΜΠΟΡΙΑ ΗΛΕΚΤΡΟΛΟΓΙΚΩΝ',
    investmentPlace: 'Αττική',
    activeTaskId: 'submit_application',
    programs: [],
    programsCount: 2,
    fundingScheme: {
      totalBudget: '892.000,00€',
      grant: null,
      ownParticipation: null,
      bankLoan: null,
    },
    applicationDate: '25/05/2024',
    submissionDate: '25/05/2024',
  },
  {
    key: 3,
    id:'4f700ae1-f6f8-4242-9f6c-bc9fc6657bc3',
    aa: '102583',
    afm: '761213247',
    name: 'Ι.Λαντζανάτου ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ ΕΜΠΟΡΙΑ ΗΛΕΚΤΡΟΛΟΓΙΚΩΝ',
    investmentPlace: 'Χανιά',
    activeTaskId: 'application_evaluation',
    programs: [],
    programsCount: 2,
    fundingScheme: {
      totalBudget: '100.000.000,00€',
      grant: null,
      ownParticipation: null,
      bankLoan: null,
    },
    applicationDate: '-',
    submissionDate: '-',
  },
  {
    key: 4,
    id:'4f700ae1-f6f8-4242-9f6c-bc9fc6657bc3',
    aa: '102586',
    afm: '311213244',
    name: 'Ι.Λαντζανάτου ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ ΕΜΠΟΡΙΑ ΗΛΕΚΤΡΟΛΟΓΙΚΩΝ',
    investmentPlace: 'Χανιά',
    activeTaskId: 'application_evaluation',
    programs: [],
    programsCount: 2,
    fundingScheme: {
      totalBudget: '76.000,00€',
      grant: null,
      ownParticipation: null,
      bankLoan: null,
    },
    applicationDate: '25/05/2024',
    submissionDate: '25/05/2024',
  },
  {
    key: 5,
    id:'4f700ae1-f6f8-4242-9f6c-bc9fc6657bc3',
    aa: '102587',
    afm: '611213277',
    name: 'Ι.Λαντζανάτου ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ ΕΜΠΟΡΙΑ ΗΛΕΚΤΡΟΛΟΓΙΚΩΝ',
    investmentPlace: 'Άρτα',
    activeTaskId: 'Center of Excellence',
    programs: [],
    programsCount: 2,
    fundingScheme: {
      totalBudget: '530.000,00€',
      grant: null,
      ownParticipation: null,
      bankLoan: null,
    },
    applicationDate: '25/05/2024',
    submissionDate: '-',
  },
];


export const TABLE_DATA = APPLICATIONS.map((row) => {
  const programs = row.programs || [];
  const hasExtraProgram = programs.length > 1;
  const funding = row.fundingScheme || {};
  const hasFundingExtra =
    funding.grant || funding.ownParticipation || funding.bankLoan;

  const hasDetailRow = hasExtraProgram || hasFundingExtra;

  return {
    ...row,
    children: !hasDetailRow
      ? undefined
      : [
          {
            ...row,
            key: `${row.id}-detail`,
            isDetail: true, // 👈 mark as detail row
          },
        ],
  };
});